module.exports = __webpack_public_path__ + "static/media/in-de-luwte-logo.a01e5264.png";